import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { IClientTransferProgress } from "./Table";
import { Fetch } from "../../shared/Fetch";

interface IProps{
    singleData: IClientTransferProgress,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema=yup.object({
    category: yup.string().required("Category is required"),
    minWet: yup.number().nullable().typeError('Only number is allowed'),
    maxWet: yup.number().nullable().typeError('Only number is allowed'),
    bonus: yup.number().nullable().typeError('Only number is allowed'),
    actions: yup.string().nullable(),
});


export const Form = (props: IProps) => {
    const [saveDis,setSaveDis] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IClientTransferProgress>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const saveToDB = async (body: IClientTransferProgress) => {
        const method = props.singleData.category != "" ? "PUT" : "POST";
        const message = props.singleData.category != "" ? "Updated Successfully" : "Added Successfully";
        
        const response = await Fetch("tbl_client_transfer_progress", method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const onSubmit=(data: IClientTransferProgress)=>{
        setSaveDis(true);
        saveToDB(data);
    }

    const onHide=()=>{
        props.setReload(!props.reload);
        props.hideDialog();
    }

    useEffect(()=>{
        reset(props.singleData);
    },[props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Client Transfer Progress Setting" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Category:" control={control} name="category" error={errors.category?.message} />
                <JVInput label="Min:" control={control} name="minWet" error={errors.minWet?.message} />
                <JVInput label="Max:" control={control} name="maxWet" error={errors.maxWet?.message} />
                <JVInput label="Bonus:" control={control} name="bonus" error={errors.bonus?.message} />
                <JVInput label="Action:" control={control} name="actions" error={errors.actions?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}